import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LibNotificationComponent } from './notification.component';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [
    LibNotificationComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [
    LibNotificationComponent
  ]
})
export class LibNotificationModule { }
